<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><a id="part01"><strong>PART<br/>I</strong></a></h2><a id="part01">
<p class="poem">“… With your moccasins of dark cloud, come to us!<br/>With your leggings of dark cloud, come to us!<br/>With your shirt of dark cloud, come to us!<br/>With your headdress of dark cloud, come to us!</p>
</a><p class="poem"><a id="part01">… Today take out your spell for me.”</a><a id="page_2"></a></p><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?1eb8a25a